import isEqual from 'lodash/isEqual';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
export const OFFLINE_STORE_NAME = 'towns/offlineStore';
export const generateOfflineUserKey = (spaceId, walletAddress) => {
    return `${spaceId}-${walletAddress}`;
};
export const useOfflineStore = create()(persist((set) => ({
    skipIsRegisteredCheck: {},
    setSkipIsRegisteredCheck(userAddress) {
        set((state) => {
            if (state.skipIsRegisteredCheck[userAddress] === true) {
                return state;
            }
            return {
                ...state,
                skipIsRegisteredCheck: {
                    ...state.skipIsRegisteredCheck,
                    [userAddress]: true,
                },
            };
        });
    },
    offlineSpaceInfoMap: {},
    setOfflineSpaceInfo(spaceInfo) {
        set((state) => {
            if (isEqual(state.offlineSpaceInfoMap[spaceInfo.networkId], spaceInfo)) {
                return state;
            }
            return {
                ...state,
                offlineSpaceInfoMap: {
                    ...state.offlineSpaceInfoMap,
                    [spaceInfo.networkId]: spaceInfo,
                },
            };
        });
    },
    offlineChannelMetadataMap: {},
    setOfflineChannelInfo(value) {
        set((state) => {
            if (isEqual(state.offlineChannelMetadataMap[value.channel.channelNetworkId], value)) {
                return state;
            }
            return {
                ...state,
                offlineChannelMetadataMap: {
                    ...state.offlineChannelMetadataMap,
                    [value.channel.channelNetworkId]: value,
                },
            };
        });
    },
    offlineWalletAddressMap: {},
    setOfflineWalletAddress: (userId, abstractAccountAddress) => set((state) => {
        if (state.offlineWalletAddressMap[userId] === abstractAccountAddress) {
            return state;
        }
        return {
            ...state,
            offlineWalletAddressMap: {
                ...state.offlineWalletAddressMap,
                [userId]: abstractAccountAddress,
            },
        };
    }),
    removeOfflineWalletAddress: (userId) => set((state) => {
        const { [userId]: _, ...rest } = state.offlineWalletAddressMap;
        return {
            ...state,
            offlineWalletAddressMap: rest,
        };
    }),
    offlineUserBioMap: {},
    setOfflineUserBio: (userId, bio) => {
        set((state) => {
            if (state.offlineUserBioMap[userId] === bio) {
                return state;
            }
            return {
                ...state,
                offlineUserBioMap: {
                    ...state.offlineUserBioMap,
                    [userId]: bio,
                },
            };
        });
    },
}), {
    name: OFFLINE_STORE_NAME,
    storage: createJSONStorage(() => localStorage),
    version: 2,
}));
//# sourceMappingURL=use-offline-store.js.map